"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const compact_1 = __importDefault(require("lodash/compact"));
const useGroupObjectives_1 = require("hooks/api/useGroupObjectives");
const useObjectives_1 = require("hooks/api/useObjectives");
const useIntersectionObserver_1 = __importDefault(require("hooks/useIntersectionObserver"));
const useUrl_1 = require("hooks/useUrl");
const HelperUtils_1 = require("utils/HelperUtils");
const ObjectivesHelper_1 = require("utils/ObjectivesHelper");
const VisibilityHelper_1 = require("utils/VisibilityHelper");
const HeaderPage_1 = __importDefault(require("components/admin/HeaderPage"));
const AdvancedFilterObjectives_1 = __importDefault(require("components/advance-filter/AdvancedFilterObjectives"));
const Accordion_1 = __importDefault(require("components/design-system/accordion/Accordion"));
const Objectives_1 = __importDefault(require("components/objectives/Objectives"));
const ObjectiveSkeleton_1 = __importDefault(require("components/shared/ObjectiveSkeleton"));
const SidebarMyGoals_1 = __importDefault(require("components/sidebar/SidebarMyGoals"));
const listTab = ['company', 'directorate', 'department', 'division'];
const CompanyGoals = ({ route: { title }, history }) => {
    var _a, _b;
    const { match } = (0, useUrl_1.useUrl)();
    const params = (0, react_router_dom_1.useParams)();
    const { isGoalCreator, isGrouping, isShowTab } = (0, VisibilityHelper_1.usePermission)();
    const switchOptions = (0, compact_1.default)(listTab.map((tab) => {
        if (tab == 'company' || isShowTab(tab)) {
            return {
                id: tab,
                name: (0, HelperUtils_1.capitalize)((0, HelperUtils_1.getObjectiveLocale)(tab)),
                filter: { [VisibilityHelper_1.listGoalType[tab]]: true },
                onClick: () => history.replace(`/goals/level/${tab}`)
            };
        }
    })) || [];
    const defaultTab = ((_a = switchOptions === null || switchOptions === void 0 ? void 0 : switchOptions.find((tab) => (tab === null || tab === void 0 ? void 0 : tab.id) === (params === null || params === void 0 ? void 0 : params.tab))) === null || _a === void 0 ? void 0 : _a.id) ||
        ((_b = switchOptions[0]) === null || _b === void 0 ? void 0 : _b.id);
    const [activeTab, changeTab] = (0, react_1.useState)(defaultTab);
    const optionActive = switchOptions.find((option) => (option === null || option === void 0 ? void 0 : option.id) === activeTab) || {};
    const goalType = VisibilityHelper_1.listGoalType[optionActive === null || optionActive === void 0 ? void 0 : optionActive.id];
    const extraFilter = (optionActive === null || optionActive === void 0 ? void 0 : optionActive.filter) || {};
    const objectivesProps = {
        cardModel: 'goal-list',
        extraFilter: extraFilter,
        page: `companyGoals+${activeTab}`,
        emptyStateAction: () => history.replace({
            pathname: '/create-objective/goal',
            state: {
                prevPath: location.pathname,
                [goalType]: true
            }
        })
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderPage_1.default, { titlePage: title, primaryAction: isGoalCreator(optionActive.id) && {
                title: (0, HelperUtils_1.getObjectiveLocale)(`Create New ${(0, HelperUtils_1.capitalize)(optionActive.id)} Goals`),
                icon: 'icon-add',
                onClick: () => {
                    history.replace({
                        pathname: '/create-objective/goal',
                        state: {
                            prevPath: location.pathname,
                            [goalType]: true
                        }
                    });
                }
            }, tabs: {
                tabsList: switchOptions,
                url: '/goals/level/company',
                // @ts-ignore
                onChange: changeTab
            } }),
        react_1.default.createElement("div", { className: "grid gap-[24px] mb-[64px] mt-[24px] company-goals" },
            react_1.default.createElement(AdvancedFilterObjectives_1.default, { filterOptions: ['search', 'dateFilter', 'menuFilter'], defaultDateFilterOptions: ['annual', 'all_time', 'last_year'], page: `companyGoals+${activeTab}`, filterId: "companyGoalsFilter", exceptFilterMenu: ['myInvolvement'] }, isGrouping(optionActive === null || optionActive === void 0 ? void 0 : optionActive.id) ? (react_1.default.createElement(ObjectivesGroup, Object.assign({ optionActive: optionActive }, objectivesProps))) : (react_1.default.createElement(Objectives_1.default, Object.assign({}, objectivesProps))))),
        react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement("div", null) }, match && react_1.default.createElement(SidebarMyGoals_1.default, null))));
};
const ObjectivesGroup = (_a) => {
    var _b;
    var { optionActive, cardModel, extraFilter, page, emptyStateAction } = _a, rest = __rest(_a, ["optionActive", "cardModel", "extraFilter", "page", "emptyStateAction"]);
    const { filter } = rest;
    const [groupData, setGroupData] = (0, react_1.useState)({});
    const { isFetching, hasNextPage, fetchNextPage } = (0, useGroupObjectives_1.useGetGroupObjectives)('myGoals', optionActive === null || optionActive === void 0 ? void 0 : optionActive.id, {
        suspense: false,
        onSuccess: (data) => {
            var _a;
            const newData = {
                key: '',
                metadata: null,
                values: []
            };
            (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.map((page) => {
                const data = page === null || page === void 0 ? void 0 : page.data;
                newData.key = data === null || data === void 0 ? void 0 : data.key;
                newData.metadata = data === null || data === void 0 ? void 0 : data.metadata;
                newData.values.push(...((data === null || data === void 0 ? void 0 : data.values) || []));
            });
            newData && setGroupData(newData);
        }
    });
    const intersectTarget = (0, react_1.createRef)();
    (0, useIntersectionObserver_1.default)({
        target: intersectTarget,
        onIntersect: (entry) => {
            var _a, _b;
            return entry.isIntersecting &&
                hasNextPage &&
                !isFetching &&
                ((_b = (_a = groupData === null || groupData === void 0 ? void 0 : groupData.metadata) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.nextOffset) &&
                fetchNextPage();
        },
        threshold: 0.5
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (optionActive === null || optionActive === void 0 ? void 0 : optionActive.id) === (groupData === null || groupData === void 0 ? void 0 : groupData.key) &&
            ((_b = groupData.values) === null || _b === void 0 ? void 0 : _b.map((data, idx) => {
                var _a, _b;
                const groupFilter = Object.assign(Object.assign({}, extraFilter), (0, ObjectivesHelper_1.restructureFilter)(Object.assign(Object.assign({}, filter), { owner: {
                        [groupData.key]: data === null || data === void 0 ? void 0 : data.name
                    } })));
                return (react_1.default.createElement("div", { "data-cy": "group-objectives", key: `${groupData === null || groupData === void 0 ? void 0 : groupData.key}-${data === null || data === void 0 ? void 0 : data.name}-${idx}`, ref: idx == ((_a = groupData === null || groupData === void 0 ? void 0 : groupData.values) === null || _a === void 0 ? void 0 : _a.length) - 1 &&
                        ((_b = groupData === null || groupData === void 0 ? void 0 : groupData.values) === null || _b === void 0 ? void 0 : _b.length) > 9
                        ? intersectTarget
                        : undefined },
                    react_1.default.createElement(Accordion_1.default, { useBorder: true, key: `${groupData === null || groupData === void 0 ? void 0 : groupData.key}-${data === null || data === void 0 ? void 0 : data.name}-${idx}` },
                        react_1.default.createElement(AccordionHeader, { data: data, groupFilter: groupFilter }),
                        react_1.default.createElement(Accordion_1.default.Content, { useSeparator: true, customClass: "overflow-y-auto max-h-[568px]", customSpaceClass: "px-[24px] py-[16px]" },
                            react_1.default.createElement(Objectives_1.default, { extraFilter: groupFilter, page: page, cardModel: cardModel, emptyStateAction: emptyStateAction, isRefetch: isFetching, useObjectiveGroup: true })))));
            })),
        ((optionActive === null || optionActive === void 0 ? void 0 : optionActive.id) !== (groupData === null || groupData === void 0 ? void 0 : groupData.key) || isFetching) && (react_1.default.createElement(ObjectiveSkeleton_1.default, null))));
};
const AccordionHeader = ({ data, groupFilter }) => {
    var _a;
    const filterCount = Object.assign(Object.assign({}, groupFilter), { ignoreInvolvements: true });
    (filterCount === null || filterCount === void 0 ? void 0 : filterCount.limit) && (filterCount === null || filterCount === void 0 ? true : delete filterCount.limit);
    const { data: totalObjectivesData } = (0, useObjectives_1.useGetTotalObjectives)(filterCount, {
        staleTime: 5 * 60 * 1000
    });
    const totalObjectives = ((_a = totalObjectivesData === null || totalObjectivesData === void 0 ? void 0 : totalObjectivesData.data) === null || _a === void 0 ? void 0 : _a.totalObjectives) || 0;
    return (react_1.default.createElement(Accordion_1.default.Header, { customSpaceClass: "px-[24px] py-[16px]" },
        react_1.default.createElement("div", { className: "w-full h-[36px] flex items-center justify-between border-solid border-y-0 border-r-[1px] border-l-0 border-n-400 border" },
            react_1.default.createElement("p", { className: "typography-h500" }, data === null || data === void 0 ? void 0 : data.name),
            react_1.default.createElement("p", { className: "typography-h100 text-n-800 px-[16px]" }, (0, HelperUtils_1.getObjectiveLocale)(`${totalObjectives} Goal${totalObjectives > 1 ? 's' : ''}`)))));
};
exports.default = CompanyGoals;
